import { Nilable } from "@shared/utils";

export interface ICuoteoResultadoDTO {
    optimalStatus: Blob;
    optimalDataset: Blob;
    nonOptimalStatus: Blob;
    nonOptimalDataset: Blob;
    datasetName?: string;
    filter_by?: string[];
    order_by?: string[];
}

export class CuoteoResultadoDTO {
    public optimalStatus: Blob;
    public optimalDataset: Blob;

    public nonOptimalStatus: Blob;
    public nonOptimalDataset: Blob;

    public datasetName = "";
    public filtradoPor: string[] = [];
    public ordernadoPor: string[] = [];

    constructor(json: Nilable<Partial<ICuoteoResultadoDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<ICuoteoResultadoDTO>) {
        if (json.optimalStatus != null) {
            this.optimalStatus = new Blob([json.optimalStatus], { type: "text/csv;charset=utf-8" });
        }
        if (json.nonOptimalStatus != null) {
            this.nonOptimalStatus = new Blob([json.nonOptimalStatus], { type: "text/csv;charset=utf-8" });
        }
        if (json.optimalDataset != null) {
            this.optimalDataset = new Blob([json.optimalDataset], { type: "text/csv;charset=utf-8" });
        }
        if (json.nonOptimalDataset != null) {
            this.nonOptimalDataset = new Blob([json.nonOptimalDataset], { type: "text/csv;charset=utf-8" });
        }
    }

    public toJSON(): ICuoteoResultadoDTO {
        return {
            optimalStatus: this.optimalStatus,
            nonOptimalStatus: this.nonOptimalStatus,
            optimalDataset: this.optimalDataset,
            nonOptimalDataset: this.nonOptimalDataset
        };
    }
}
